import React, { FC, useState } from 'react';

import { Row, Spacer, Column } from '@components/1-atoms/Miscellaneous';
import CardBase /* Card as CardBase */ from '@components/1-atoms/Card';
import Text from '@components/1-atoms/Text';


import { Button } from '@components/2-molecules/Buttons';
import Info from '@components/2-molecules/Info';

import SubscriptionList from '@components/3-organisms/Lists/ListSubscription';

import subscription, { SubscriptionPackage } from '@lib/subscription';

import Stripe from '@assets/stripe';
import styled, { css } from '@emotion/native';
import { NavigationProp } from '@react-navigation/native';
import { useAppAlerts } from '@lib/hooks/base/useAppAlerts';


const Card = styled(CardBase)` `;


type Props = {
    navigation: NavigationProp<any>;
};

const Subscriptions: FC<Props> = ({ navigation }) => {

    const [packages, setPackages] = useState<SubscriptionPackage[]>([]);
    const [selectedPackage, setSelectedPackage] = useState<SubscriptionPackage | null>(null);

    
    const alerts = useAppAlerts();  

    // Set subscription packages
    React.useEffect(() => {
        const fetchPackages = async () => {
            const fetchedPackages = await subscription.getSubscriptionPackages();
            setPackages(fetchedPackages);
            setSelectedPackage(fetchedPackages[0]);

        };
        fetchPackages();
    }, []);

    // Purchase selected package
    const _purchase = () => selectedPackage?.purchase(alerts.alert);

    return (
        <Card>
            <Row>
                <Column>
                    <Text large>Subscriptions</Text>
                    <Spacer h={0.3} />
                    <Text small>Start with a free trial - no credit card required</Text>
                </Column>
                <Spacer w={1} />

                {/* <Stripe /> */}
            </Row>

            <SubscriptionList
                inset
                scrollEnabled={false}
                defaultValue={selectedPackage}
                data={packages}
                onPress={ (pkg) => setSelectedPackage(pkg) }
            />

            <Spacer h={1} />

            <Info>
                The subscriptions are cancellable at anytime.{'\n'}
                After your Free Trial, an auto-renewable paid subscription will be activated for you.{'\n'}
            </Info>

            <Spacer h={1} />
            <Button inset outlined disabled={!selectedPackage} onPress={_purchase}>ENROLL</Button>
        </Card>
    );
};

export default Subscriptions;